export const ACCEPTED_STATUS = 202
export const MIN_ERROR_STATUS = 400
